<template>
    <b-col>
    <recognition-decision-form></recognition-decision-form>
    </b-col>
</template>

<script>
 import RecognitionDecisionForm from '@/components/applicant/recognation/RecognitionDecisionForm'
    export default {
        name: "Index",
        components:{
          RecognitionDecisionForm
        },
        computed:{

        },
       methods:{
         fetchRecognition(){
            this.$store.dispatch('applicant/actionSetRecognition', this.$route.params.id)
          }
        },
    }
</script>

<style scoped>

</style>